// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"

// Adding a new custom action to Turbo Stream
// to use the new action to redirect to a new page from controller you have two options:
// 1. Rendering inline in a controller
//    => `render turbo_stream: turbo_stream.redirect(your_path)`
// 2. Using an *.turbo_stream.haml file
//    => `<turbo-stream action="redirect" url="<%= your_path %>"></turbo-stream>`
// 3. Using an *.turbo_stream.erb file
//    => <%= turbo_stream.redirect(your_path) %>
Turbo.StreamActions.redirect = function() {
  const url = this.getAttribute('url') || '/'
  // action: 'advance' will push a new entry to the history stack of the browser (like a redirect)
  Turbo.visit(url, { frame: '_top', action: 'advance' })
}